import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@domain-group/fe-co-avatar';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { AgentAwardPill } from '@domain-group/fe-co-allhomes-shared-components';
import { useAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Button, CallButton } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentCard = _ref => {
  var _agent$phone, _agent$highlightedAwa;
  var agent = _ref.agent,
    className = _ref.className,
    onClickCall = _ref.onClickCall,
    onClickEmail = _ref.onClickEmail,
    onClickAgentCard = _ref.onClickAgentCard;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var _ref2 = useAllhomesContext() || {},
    isEuUser = _ref2.isEuUser;
  var callClicked = () => {
    onClickCall(agent.id, agent.name, agent.phone, 'Agent Icons');
  };
  var emailClicked = () => {
    sendEvent('email-click');
    onClickEmail(agent.id, agent.name, 'Agent Icons');
  };
  var agentCardClicked = () => {
    sendEvent('card-click');
    onClickAgentCard();
  };
  var hasEmailButton = agent.emailContactable && !isEuUser;
  var hasPhoneButton = ((_agent$phone = agent.phone) === null || _agent$phone === void 0 ? void 0 : _agent$phone.length) > 0;
  return ___EmotionJSX("div", {
    className: className,
    css: styles.agentCard,
    key: agent.id
  }, ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX(Avatar, {
    css: styles.avatarImage,
    imageUrl: agent.profilePhoto,
    size: "custom",
    shape: "circle",
    colorScheme: "dark",
    theme: "allhomes"
  }), ___EmotionJSX("div", {
    css: styles.nameAndDesignation
  }, ___EmotionJSX("a", {
    css: styles.name,
    href: agent.url,
    onClick: agentCardClicked
  }, agent.name), ___EmotionJSX("span", {
    css: styles.designation
  }, agent.jobTitle))), ((_agent$highlightedAwa = agent.highlightedAwards) === null || _agent$highlightedAwa === void 0 ? void 0 : _agent$highlightedAwa.length) > 0 && agent.highlightedAwards.map(award => ___EmotionJSX(AgentAwardPill, {
    label: award.badgeLabel
  })), ___EmotionJSX("div", {
    css: styles.buttons
  }, hasPhoneButton && ___EmotionJSX(CallButton, {
    css: styles.callButton,
    phone: agent.phone,
    onClick: callClicked
  }), hasEmailButton && ___EmotionJSX(Button, {
    appearance: "neutralFilled",
    icon: ___EmotionJSX(EmailIcon, null),
    iconPosition: "left",
    onClick: emailClicked,
    css: styles.emailButton
  }, "Email")));
};
export var propTypes = {
  agent: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string]),
    name: PropTypes.string.isRequired,
    profilePhoto: PropTypes.string,
    emailContactable: PropTypes.bool,
    phone: PropTypes.string,
    url: PropTypes.string.isRequired,
    jobTitle: PropTypes.string,
    highlightedAwards: PropTypes.arrayOf(PropTypes.shape({
      badgeLabel: PropTypes.string.isRequired
    }))
  }).isRequired,
  className: PropTypes.string,
  onClickCall: PropTypes.func,
  onClickEmail: PropTypes.func,
  onClickAgentCard: PropTypes.func
};
AllhomesAgentCard.propTypes = propTypes;
AllhomesAgentCard.defaultProps = {
  className: '',
  onClickCall: () => {},
  onClickEmail: () => {},
  onClickAgentCard: () => {}
};
export default withEventBoundary(_ref3 => {
  var agent = _ref3.agent;
  return {
    name: 'agent-card',
    data: {
      agent
    }
  };
})(AllhomesAgentCard);